export const THEME_COLORS = {
  primary: '#127CF3',
  primaryLight: '#28A8FF',
  primaryDark: '#0E5FBF',

  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',

  light: {
    bg: '#FFFFFF',
    paper: '#F8FAFC',
    text: '#1A1A2E',
    textSecondary: '#64748B',
    divider: '#E2E8F0',
    tableHeader: '#F1F5F9',
    tableIndexHeader: '#E2E8F0',
    tableIndexBody: '#F8FAFC',
    hover: 'rgba(18, 124, 243, 0.08)',
    selected: 'rgba(18, 124, 243, 0.12)',
  },

  dark: {
    bg: '#0F0F1A',
    paper: '#1A1A2E',
    text: '#F1F5F9',
    textSecondary: '#94A3B8',
    divider: '#2D2D44',
    tableHeader: '#1E1E32',
    tableIndexHeader: '#252540',
    tableIndexBody: '#1A1A2E',
    hover: 'rgba(18, 124, 243, 0.16)',
    selected: 'rgba(18, 124, 243, 0.24)',
  },

  badge: {
    gray: { bg: '#F1F5F9', text: '#475569' },
    red: { bg: '#FEE2E2', text: '#DC2626' },
    orange: { bg: '#FFEDD5', text: '#EA580C' },
    yellow: { bg: '#FEF3C7', text: '#D97706' },
    green: { bg: '#D1FAE5', text: '#059669' },
    blue: { bg: '#DBEAFE', text: '#2563EB' },
    purple: { bg: '#EDE9FE', text: '#7C3AED' },
    pink: { bg: '#FCE7F3', text: '#DB2777' },
  },

  badgeDark: {
    gray: { bg: '#374151', text: '#D1D5DB' },
    red: { bg: '#7F1D1D', text: '#FCA5A5' },
    orange: { bg: '#7C2D12', text: '#FDBA74' },
    yellow: { bg: '#78350F', text: '#FCD34D' },
    green: { bg: '#064E3B', text: '#6EE7B7' },
    blue: { bg: '#1E3A8A', text: '#93C5FD' },
    purple: { bg: '#4C1D95', text: '#C4B5FD' },
    pink: { bg: '#831843', text: '#F9A8D4' },
  },
} as const

export function getBadgeColorByValue(value: string, isDarkMode = false): { bg: string; text: string } {
  const hash = value.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  const colors = isDarkMode ? THEME_COLORS.badgeDark : THEME_COLORS.badge
  const keys = Object.keys(colors) as (keyof typeof colors)[]
  const key = keys[hash % keys.length]
  return colors[key]
}

export function getHeatmapColor(value: number, min: number, max: number, isDarkMode = false): string {
  const normalized = Math.max(0, Math.min(1, (value - min) / (max - min || 1)))

  if (isDarkMode) {
    const r = Math.round(30 + normalized * 150)
    const g = Math.round(30 + (1 - normalized) * 100)
    const b = Math.round(50)
    return `rgb(${r}, ${g}, ${b})`
  }

  const r = Math.round(255 - normalized * 50)
  const g = Math.round(255 - normalized * 150)
  const b = Math.round(200 - normalized * 100)
  return `rgb(${r}, ${g}, ${b})`
}
